// Panda V2 color tokens from Figma — a distinct visual system from the legacy
// chat, so kept with the feature rather than the platform palettes. Mobile
// consumes the object directly in StyleSheets; web mirrors it as --panda-*
// CSS custom properties on the chat drawer root (see panda-chat-v2.tsx).
export const PANDA_COLORS = {
  actionPrimary: '#3f5fd1',
  actionSecondaryBackground: '#1a202f0a',
  actionSecondaryBorder: '#1a202f14',
  actionSecondaryText: '#4f5977',
  textOnAction: '#ffffff',
  textLink: '#2a48b0',
  textPrimary: '#0d142d',
  textSecondary: '#626e87',
  textPlaceholder: '#848ea4',
  surface: '#ffffff',
  surfaceSubtle: '#ebeff4',
  backgroundAccentTint: '#eef3ff',
  borderDefault: '#dde3eb',
  borderSubtle: '#ebeff4',
  borderStrong: '#cbd2de',
  error: '#c0392b',
  // Search-answer card accents (side bar / "show more" link).
  accentBar: '#d87236',
  accentLink: '#e46b22',
  // Source content-type chip fills, by the authority the source carries. The
  // secondary chip also takes a borderDefault outline; the primary one has none.
  chipPrimaryBackground: '#86e4a2',
  chipSecondaryBackground: '#e2f2fa',
  // Hub-answer content-type chip fill (accent tag in the design); label uses textOnAction.
  chipHubBackground: '#ad6de7',
  // Subtle inline-bar surface (connection-loss bar) — same value for fill and border.
  surfaceOverlay: 'rgba(0, 0, 0, 0.04)',
} as const;
